import React from "react";
import StackedList, { StackedListItem } from "../Lists/StackedList";
import Pill from "components/Text/Pill";
import { LockOpenIcon, LockClosedIcon } from "@heroicons/react/outline";
import { fromSqlDateTime } from "helpers/Date";
import { packClasses } from "Utils";
import { background as statusColors } from "constants/status-colors";

export default function ContentStackedList(props) {
    const bubbleClickAction = (item) => {
        if (props.onSelect) {
            return props.onSelect.call(null, item);
        }
    };

    return (
        <StackedList>
            {props.items.map((item, index) => (
                <StackedListItem key={index}>
                    <ContentStackedListItem
                        item={item}
                        onSelect={bubbleClickAction}
                    />
                </StackedListItem>
            ))}
        </StackedList>
    );
}

export function ContentStackedListItem(props) {
    const handleClick = (e) => {
        if (props.onSelect) {
            props.onSelect.call(null, props.item);
        }
    };

    return (
        <div className={packClasses("block hover:bg-gray-50")}>
            <div className={packClasses("px-4 py-4 sm:px-6")}>
                <div className="flex items-start space-x-4">
                    <div>
                        <span
                            className={packClasses(
                                "mx-0 mt-3 inline-block h-3 w-3 rounded-full leading-none",
                                statusColors[props.item.status]
                            )}
                        >
                            &nbsp;
                        </span>
                    </div>
                    <div className="flex-grow-1 items-start text-left">
                        <span
                            className="color-gray-400 mb-2 block cursor-pointer truncate text-sm hover:underline"
                            onClick={handleClick}
                        >
                            {props.item.title}
                        </span>
                        <Pill
                            className={packClasses(
                                "border border-transparent bg-gray-100 text-gray-700"
                            )}
                        >
                            {props.item.workflow && props.item.workflow.uuid ? (
                                props.item.workflow.name
                            ) : (
                                <span className="text-gray-300">None</span>
                            )}
                        </Pill>{" "}
                        {props.item.lock && props.item.lock.user ? (
                            <Pill
                                className={packClasses(
                                    "border border-transparent bg-gray-100 text-red-700"
                                )}
                            >
                                <LockClosedIcon className=" mr-1 h-2.5 w-2.5" />{" "}
                                {props.item.lock.user.name}
                            </Pill>
                        ) : (
                            <Pill
                                className={packClasses(
                                    "border border-transparent bg-gray-100 text-gray-700"
                                )}
                            >
                                <LockOpenIcon className="mr-1 h-2.5 w-2.5 text-gray-900" />{" "}
                                Available
                            </Pill>
                        )}
                        <span className="ml-0 mt-2 block text-xs text-gray-800 sm:mt-0 sm:ml-4 sm:inline">
                            {fromSqlDateTime(props.item.modified_at).toFormat(
                                "ff"
                            )}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
